import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#464646',
        secondary: '#b0bec5',
        accent: '#97d5a4',
        error: '#b71c1c',
        black: '#090909',
      },
    },
  },
};

export default new Vuetify(opts);
